"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var RApolloProvider = react_apollo_1.ApolloProvider;
var AppProvider = /** @class */ (function (_super) {
    tslib_1.__extends(AppProvider, _super);
    function AppProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppProvider.prototype.render = function () {
        return (React.createElement(user_context_provider_1.UserContextProvider, { user: this.props.user },
            React.createElement(RApolloProvider, { client: this.props.client }, this.props.children)));
    };
    AppProvider = tslib_1.__decorate([
        react_tracking_1.default({}, { dispatch: tracker_1.trackEvents })
    ], AppProvider);
    return AppProvider;
}(React.Component));
exports.default = AppProvider;
//# sourceMappingURL=app_provider.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/app_provider.js
// module id = ZmlK
// module chunks = 20 21